<script>
    export let title, number, position, style;
    export let text = undefined;
    export let isOpen = false;
    let styleInternal = style;
    let displayN = "display: none;";
    let display = "display: block;";

    $: if (isOpen) styleInternal = style.replace(displayN, display);
    else styleInternal = style;

    function clickOutside(element, callbackFunction) {
        function onClick(event) {
            if (!element.contains(event.target)) {
                callbackFunction();
            }
        }

        document.body.addEventListener("click", onClick);

        return {
            update(newCallbackFunction) {
                callbackFunction = newCallbackFunction;
            },
            destroy() {
                document.body.removeEventListener("click", onClick);
            },
        };
    }
</script>

<div class="popover fade {position} in" style={styleInternal}>
    <div class="arrow" />
    <div
        class="popover-inner"
        use:clickOutside={() => {
            isOpen = false;
        }}
    >
        <h3 class="popover-title">{title}</h3>
        <div class="popover-content">
            <div class="popover-icon">{number}</div>
            <slot>
                <p>{text}</p>
            </slot>
        </div>
    </div>
</div>
